export default {
  SET_BAR_IMAGE(state, payload) {
    state.barImage = payload
  },
  setDrawer(state, payload) {
    state.drawer = payload
  },
  TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : ''
  },
  saveTableSettings(state, { id, ...options }) {
    const newState = state.tableSettings.filter(item => item.id !== id)
    newState.push({ id, ...options })
    state.tableSettings = newState
  },
  clearTableSettings(state) {
    state.tableSettings = []
  },
}
